import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";

import { fuseAnimations } from "@fuse/animations";

import { BaseComponent } from "../../base-module/base-component/base.component";

import { AuthService } from "app/base-module/base-service/auth.service";
import { ClientesDivergenciaCustodiaService } from "../services/clientes-divergencia-custodia.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PageEvent } from "@angular/material/paginator";

@Component({
    selector: "lista-divergencia-corretora-prosper",
    templateUrl: "./lista-divergencia-corretora-prosper.component.html",
    styleUrls: ["./lista-divergencia-corretora-prosper.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations,    
    providers: [ ClientesDivergenciaCustodiaService ]
    
})

export class ListaDivergenciaCorretoraProsperComponent extends BaseComponent implements OnInit {

    usuario:any;
    loadingListaAtivo: boolean = false;   
    user:any;
    
    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl?: TemplateRef<any>;
    @ViewChild(ListaDivergenciaCorretoraProsperComponent, { static: false }) table?: ListaDivergenciaCorretoraProsperComponent;

    constructor(public service: ClientesDivergenciaCustodiaService, 
                public dialog: MatDialog, 
                override snackBar: MatSnackBar,
                private _authService: AuthService ) {
        super(dialog, snackBar);
        this.getAll();

        this.user = JSON.parse(this._authService.getUser() ?? "{}");
    }

    ngOnInit() {
    }
    
    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){
        this.params.page = (event.pageIndex+1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }
    
    /**
     * Evento de ordenação da lista de produtos
     * @param event
    */
    onSort(event:any){
        this.params.sortColumn = event.column.prop;
        this.params.sortOrder = event.newValue;
        this.getAll();
    } 
    /**
     * Consulta lista de Boletas
     */
    getAll() {
        this.loadingIndicator = true;
        this.service.getAll(this.params).subscribe(
            data => {                
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error => {
                this.loadingIndicator = false;
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }  

    save(id:number){
        // this.service.create(id).subscribe(
        //     data => {
        //         console.log(data);
        //     },
        //     error => {
        //         console.log(error);
        //     }
        // );
        this.showSuccess("Custódia atualizada com sucesso!");
    }
    delete(id:number){
        this.service.delete(id).subscribe(
            data => {
                console.log(data);
            },
            error => {
                console.log(error);
            }
        );
    }
    
}
